import { Calendar, Clock, MapPin } from 'lucide-react';

interface CalendarCardProps {
  data: {
    title?: string;
    start?: string;
    end?: string;
    location?: string;
    description?: string;
    all_day?: boolean;
  };
}

export default function CalendarCard({ data }: CalendarCardProps) {
  const formatTime = (iso: string) => {
    try {
      const d = new Date(iso);
      return d.toLocaleString('en-US', { weekday: 'short', month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' });
    } catch { return iso; }
  };

  return (
    <div className="my-2 border border-purple-500/30 bg-[#0a1628]/80 backdrop-blur-sm p-3 max-w-[320px]"
         style={{ clipPath: 'polygon(0 0, calc(100% - 12px) 0, 100% 12px, 100% 100%, 12px 100%, 0 calc(100% - 12px))' }}>
      <div className="flex items-center gap-2 mb-2">
        <Calendar className="w-4 h-4 text-purple-400" />
        <span className="text-purple-300 font-semibold text-sm">{data.title || 'Event'}</span>
      </div>

      <div className="space-y-1 text-xs">
        {data.start && (
          <div className="flex items-center gap-2 text-gray-300">
            <Clock className="w-3.5 h-3.5 text-purple-400/70" />
            <span className="font-mono">
              {data.all_day ? 'All day' : formatTime(data.start)}
              {data.end && !data.all_day && ` — ${formatTime(data.end)}`}
            </span>
          </div>
        )}
        {data.location && (
          <div className="flex items-center gap-2 text-gray-300">
            <MapPin className="w-3.5 h-3.5 text-purple-400/70" />
            <span>{data.location}</span>
          </div>
        )}
        {data.description && (
          <p className="text-gray-400 mt-1 line-clamp-2">{data.description}</p>
        )}
      </div>
    </div>
  );
}
